import React from "react"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import useSuppliers from "hooks/useSuppliers"
import useStorages from "hooks/useStorages"
import EditSupplierForm from "features/storages/suppliers/editSupplierForm"
import SectionHeader from "@/components/layout/sectionHeader"
import Section from "@/components/layout/section"
import SectionHeaderTitle from "@/components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import { paramGuardStorage, paramGuardSupplier } from "@/utils/paramGuard"
import RightSidebarSupplier from "@/components/sidebar/right/RightSidebarSupplier"

const EditSupplier: React.FC = () => {
    
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { targetStorageDocId: storageId } = useTargetStorage()
    const { supplierId } = useParams<{ supplierId: string }>()
    
    const {
        supplier,
        supplierStatus
    } = useSuppliers({ storageId, supplierId })

    const { 
        storage,
        storageStatus,
        isSuppliersEnabled
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (
        !paramGuardStorage({storageId, storage, storageStatus, navigate}) ||
        !paramGuardSupplier({storageId, supplierId, supplier, supplierStatus, navigate})
    ) {
        return <></>
    }
    const safeStorageId = storageId!;
    const safeSupplierId = supplierId!;

    // Redirect if suppliers are disabled for this storage
    if (!isSuppliersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    return (
        <>
            <PageTitle title={t('titleEditSupplier')} />
            <Section>
                <EditSupplierForm 
                    supplier={supplier!}
                    storageId={safeStorageId}
                    supplierId={safeSupplierId}
                />
            </Section>
            <RightSidebarSupplier storageId={safeStorageId} supplierId={safeSupplierId} />
        </>
    )
}

export default EditSupplier
